<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<div #container
     [ngStyle]='style' fxLayout='column'
     [ngClass]="{'dash-gis-panel-minimized': minimized}"
     class='dash-gis-panel-container'
     [ngDraggable]='!isIOS' [handle]='dragHandle'
     csNg2Resizable [enableResize]='!isIOS && enableResize'
     [enableGhostResize]='true'
     [ghostElementPositioning]="'absolute'"
     [resizeCursorPrecision]='resizeHandleWidth'
     [resizeEdges]='{bottom: true, right: true, top: true, left: true}'
     (resizeEnd)='onResizeEnd($event)'>
    <mat-card fxHide.print fxShow
              fxLayout='column' class='dash-gis-panel-base' fxFlex='1 1 auto'>
        <div fxFlex='none'>
            <div #dragHandle [ngStyle]='dragHandleStyle'></div>
            <mat-toolbar class='dash-gis-panel-toolbar' color='primary' fxLayout='row'
                         fxFlex='noshrink' fxLayoutAlign='space-between center'>
                <span class='panel-title'
                      [matTooltip]='panelTitle'>{{panelTitle}}</span>
                <span>
                    <button mat-icon-button
                            *ngIf='historyEnabled'
                            matTooltip='Return to Search Criteria'
                            (click)='panelBack.emit($event)'>
                        <mat-icon svgIcon='back'></mat-icon>
                    </button>
                    <button mat-icon-button *ngIf='!minimized' (click)='onMinimize()'>
                        <mat-icon svgIcon='minimize'></mat-icon>
                    </button>
                    <button mat-icon-button *ngIf='minimized' (click)='onRestore()'>
                        <mat-icon svgIcon='restore'></mat-icon>
                    </button>
                    <button mat-icon-button
                            *ngIf='closeEnabled'
                            matTooltip='Close Search Results'
                            (click)='closePanel.emit()'>
                        <mat-icon svgIcon='close'></mat-icon>
                    </button>
                </span>
            </mat-toolbar>
        </div>
        <div [ngClass]="{'dash-gis-panel-content-minimized': minimized}"
             class='dash-gis-panel-content'
             fxLayout='column' fxFlex='1 1 auto'>
            <div [ngClass]="{
                    'dash-gis-panel-scrollable': enableScroll,
                    'dash-gis-panel-non-scrollable': !enableScroll
                 }"
                 fxFlex='1 1 auto'>
                <ng-content></ng-content>
            </div>
        </div>
    </mat-card>
</div>
